import React, { useEffect } from 'react'
import Layout from '../Layout'
import ListSemester from '../../components/semester/ListSemester'
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { getMe } from "../../features/authSlice"

const Semester = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { isError } = useSelector((state) => state.auth)

    useEffect(() => {
        dispatch(getMe())
    }, [dispatch])

    if (isError) {
        return navigate("/login")
    }

    return (
        <Layout>
            <title>Semester</title><ListSemester />
        </Layout>
    )
}

export default Semester